import React, { useEffect, useState } from 'react';
import Stylesheet from './Dashboard.module.css';
import { UserContext } from '../../contexts/user';
import { Switch, Route, Redirect } from 'react-router-dom';
import Menu from '../../components/Menu/Menu';
// App Pages
import Tables from '../../pages/Tables/Tables';
import Forms from '../../pages/Forms/Forms';
import PageNotFound from '../../pages/NotFound/NotFound';
import Accounts from '../../pages/Settings/Accounts/Accounts';
import About from '../../pages/Help/About/About';
import TableSettings from '../../pages/Settings/Tables/Tables';
import FormSettings from '../../pages/Settings/Forms/Forms';
import Profile from '../../pages/Account/Profile/Profile';
import Manual from '../../pages/Help/Manual/Manual';
import Notifications from '../../pages/Account/Notifications/Notifications';
import Navigation from '../../components/Navigation/Navigation';
import { firestore, realtime, user as appUser } from '@enigma/core/services';
import util from '@enigma/core/utilities';
import { ico_database } from '../../icon';
import Loading from '../../components/Spinner/Standard/Standard';

const Dashboard = (props) => {
    let user = null;
    const [synced, setSynced] = useState(false);
    const database = new util.database("gmgroup.fleet");
    const init = (userContext) => {user = userContext};
    const syncUsersTable = async _ => {
        return new Promise(
            async (resolve, reject) => {
                // check if local cache has been initilized
                const table = database.table('accounts');
                // create table instance on device
                if (!await table.exists()) {
                    await table.create("id", false);
                    // add record timestamp as a index for optimized querying
                    await table.index('timestamp').create("timestamp");
                } else await table.clear();
                // sync accounts
                firestore.collection('users')
                .onSnapshot(async snap => {
                    const changes = snap.docChanges();
                    for (const document of changes) {
                        // check if local cache has been initilized
                        const table = database.table('accounts');
                        // create table record on device
                        if (document.type === "added"
                        || document.type === "modified")
                            await table.document(document.doc.id).set(document.doc.data());
                        else if (document.type === "removed")
                            await table.document(document.doc.id).delete();
                    }
                    resolve();
                })
            }
        )
    }    
    const syncTables = async _ => {
        return new Promise(
            async (resolve, reject) => {
                // check if local cache has been initilized
                const table = database.table('tables');
                // create table instance on device
                if (!await table.exists()) {
                    await table.create("id", false);
                    // add record timestamp as a index for optimized querying
                    await table.index('timestamp').create("timestamp");
                } else await table.clear();
                // sync accounts
                firestore.collection('tables')
                .onSnapshot(async snap => {
                    const changes = snap.docChanges();
                    for (const document of changes) {
                        // check if local cache has been initilized
                        let table = database.table(document.doc.id);
                        // create table instance on device
                        if (!await table.exists()) {
                            await table.create("id", false);
                            // add record timestamp as a index for optimized querying
                            await table.index('timestamp').create("timestamp");
                        }
                        table = database.table('tables');
                        // create table record on device
                        if (document.type === "added"
                        || document.type === "modified")
                            await table.document(document.doc.id).set(document.doc.data());
                        else if (document.type === "removed")
                            await table.document(document.doc.id).delete();
                    }
                    resolve();
                })
            }
        )
        
    }
    const syncForms = async _ => {
        return new Promise(
            async (resolve, reject) => {
                const table = database.table('forms');
                // create table instance on device
                if (!await table.exists()) {
                    await table.create("id", false);
                    // add record timestamp as a index for optimized querying
                    await table.index('timestamp').create("timestamp");
                } else await table.clear();
                // sync accounts
                firestore.collection('forms')
                .onSnapshot(async snap => {
                    const changes = snap.docChanges();
                    for (const document of changes) {
                        // check if local cache has been initilized
                        let table = database.table(document.doc.id);
                        // create table instance on device
                        if (!await table.exists()) {
                            await table.create("id", false);
                            // add record timestamp as a index for optimized querying
                            await table.index('timestamp').create("timestamp");
                        }
                        table = database.table('forms');
                        // create table record on device
                        if (document.type === "added"
                        || document.type === "modified")
                            await table.document(document.doc.id).set(document.doc.data());
                        else if (document.type === "removed")
                            await table.document(document.doc.id).delete();
                    }
                    resolve();
                })
            }
        )
    }
    /**
     * Attach lisnter for record changes in teh database scope
     */
    const syncRecords = _ => {
        realtime.ref(`gmgroup/fleet`)
        .on("child_added", async function(snap) {
            if (!snap.val()) return;
            const record = snap.val();
            // active period refreshes every 24 hours
            const activePeriod = new Date(new Date().toDateString()).getTime();
            const database = new util.database("gmgroup.fleet");
            // check if change event has expired
            if (record.timestamp < activePeriod) {
                console.log('event has expired removing for all users');
                await snap.ref.remove();
                return;
            }
            // check if change event has already been synced
            if (record?.syncedList 
            && record.syncedList.find((uid) => uid === appUser.uid)) {
                console.log('event already synced on this device')
                return;
            } else {
                // log event for auditing
                // if (user?.admin) {
                //     console.log('logging change event for auditing');
                //     const table = database.table('logs');
                //     if (!await table.exists()) {
                //         await table.create("id", false);
                //         // add record timestamp as a index for optimized querying
                //         await table.index('timestamp').create("timestamp");
                //         await table.index('userID').create("userID");
                //         await table.index('tableID').create("tableID");
                //     }
                //     await table.document(snap.key).set(record);
                    
                // }
            }
            // check if local cache has been initilized
            const table = database.table(record.tableID);
            // record syned for current user
            if (record?.syncedList !== undefined) record.syncedList.push(appUser.uid);
            else record.syncedList = [appUser.uid];
            await snap.ref.update(record);
            // identify update type
            if (record?.type === "added")
                // sync to device
                await table.document(record.recordID).set(record.data);
            else if (record?.type === "modified")
                // sync to device
                await table.document(record.recordID).update(record.data);
            else {
                // record deleted from archives
                if (await table.document(record.recordID).exists())
                    // sync to device
                    await table.document(record.recordID).delete();
            }
        })
    }
    useEffect(() => {
        if (user === null) return;
        // sync database tables
        syncUsersTable()
        .then(async _ => {
            await syncTables();
            await syncForms();
            setSynced(true);
            // sync database table records
            syncRecords();
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])

    const content = _ => {
        if (synced) {
            return (
                <React.Fragment>
                    <div className={Stylesheet.Menu}><Menu /></div>
                    <div className={Stylesheet.Content}>
                        <div className={Stylesheet.Navigation}>
                            <Navigation />
                        </div>
                        <Switch>
                            <Route path='/account/profile' component={ Profile } />
                            <Route path='/account/notifications' component={ Notifications } />
                            <Route path='/tables/:name' component={ Tables } />
                            <Route path='/forms/:name' component={ Forms } />
                            <Route path='/settings/accounts' component={ Accounts } />
                            <Route path='/settings/tables' component={ TableSettings } />
                            <Route path='/settings/forms' component={ FormSettings } />
                            <Route path='/help/license' component={ About } />
                            <Route path='/help/manual' component={ Manual } />
                            <Route exact path='/notfound' component={ PageNotFound } />
                            <Route><Redirect to='/account/profile' /></Route>
                        </Switch>
                    </div>
                </React.Fragment>
            )
        }
        return (
            <div className={Stylesheet.Loading}> 
                <h1>{ico_database}</h1>
                <div className={Stylesheet.Spinner}>
                    <Loading show={ true } />
                </div>
            </div>
        )
    }

    return (
        <UserContext.Consumer>
            {user => (
                <div className={Stylesheet.Container}>
                    {init(user.profile)}
                    {content()}
                </div>
            )}
        </UserContext.Consumer>
    )
}

export default Dashboard;